import React from "react";
import { Breadcrumb } from "react-bootstrap";
import OutpatientVisitorForm from "../components/OutpatientVisitorForm";
import styled from "styled-components";

const Styles = styled.div`  
.list-decimal {
    list-style-type: decimal;
}

.mandatory-note {
    color: red;
}

.content-top-header {
    color: #a6192e;
}

.breadcrumb-bg { 
    background-color:#e9ecef;
}

`;

const OutpatientVisitor = () => {

    return (
        <Styles>
            <div className="row breadcrumb-bg animate__animated animate__fadeIn">
                <div className="container">
                    <Breadcrumb>
                        <Breadcrumb.Item href="https://www.ttsh.com.sg/Pages/default.aspx"><small>Home</small></Breadcrumb.Item>
                        <Breadcrumb.Item href="/"><small>Visitor Facilitation</small></Breadcrumb.Item>
                        <Breadcrumb.Item active><small>Accompanying Outpatient</small></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>

            <div className="container">
                <br />
                <div className="content-top">
                    <h3 className="content-top-header animate__animated animate__fadeInLeft animate__delay-500ms">OUTPATIENT VISITOR REGISTRATION</h3>
                    <p className="animate__animated animate__fadeInUp animate__delay-600ms">
                        This registration is meant to facilitate visitors accompanying outpatients for their appointments at the clinics located at Blocks 4, 5 and 6/7. Visitors and patients are required to access the gantries at the lift lobbies to reach the upper levels of Blocks 4, 5 and 6/7. Gantry access is valid on the day of the outpatient’s appointment. Visitors are required to abide by SGH’s visiting policy of one (1) visitor per patient.
                </p>
                </div>

                <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                <div className="content-instructions animate__animated animate__fadeInUp animate__delay-700ms">
                    <h5>INSTRUCTIONS FOR REGISTRATION</h5>

                    <ol className="list-decimal">
                        <li>Registration is non-transferable and valid only on the day of the outpatient’s appointment. Visitors who wish to accompany the outpatient on subsequent visits will have to register again.</li>
                        <li>Registration is applicable for doctor consultations at the following clinics or centres:</li>
                        <ul>
                            <li>Pain Management Centre (Acupuncture Services)</li>
                            <li>Dialysis Centre</li>
                            <li>Inpatient and Lung Endoscopy Centre</li>
                            <li>Haematology Centre</li>
                            <li>Interventional Radiology Centre</li>
                            <li>Neurodiagnostic Unit</li>
                            <li>Neurovascular Lab</li>
                        </ul>
                        <li>Visitors accompanying outpatients to clinics or centres not listed above or have received an appointment through a letter should approach the Visitor Registration Counters at Level 1 Lift Lobbies.</li>
                        <li>Visitors accompanying outpatients for day procedure or day surgery should complete the ‘Day Procedure / Day Surgery Registration’ page.</li>
                        <li>Only one (1) visitor may register for the same patient.</li>
                        <li>Registration does not give visitors unlimited access to the ward levels.</li>
                        <li>Registration is only applicable to Singaporeans, permanent residents and foreigners holding work permits or employment passes. Other foreign visitors are required to register at the Visitor Registration Counters at Level 1 Lift Lobbies.</li>
                        <li>Children below the age of 12 are not permitted to visit clinical areas.</li>
                        <li>Visitors are required to fill-in:</li>
                        <ul>
                            <li>Visitor's name and NRIC / FIN number.</li>
                            <li>Patient's full name (as in identity card), NRIC/FIN number and date of appointment.</li>
                        </ul>
                        <li>Visitors may call our general enquiries line at 0000 0000 for assistance.</li>
                    </ol>
                </div>

                <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                <div className="content-form animate__animated animate__fadeInUp animate__delay-800ms">
                    <h5>REGISTRATION FORM</h5>
                    <small className="mandatory-note">* Mandatory </small>

                    {/* Outpatient Visitor form */}
                    <OutpatientVisitorForm />
                </div>

            </div>
        </Styles>
    );
};

export default OutpatientVisitor;